import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CSidebar, CSidebarBrand } from '@coreui/react';

import logo from '../assets/images/logo.png';

const TheSidebar = () => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.sidebarShow);

  return (
    <CSidebar show={show} onShowChange={(val) => dispatch({ type: 'set', sidebarShow: val })}>
      <CSidebarBrand className="d-md-down-none sed-om-sidebar-brand" to="/">
        <div className="sed-om-sidebar-logo-wrapper">
          <div className="logo">
            <img src={logo} alt="自然電力" />
          </div>
          <p className="site">認証基盤管理システム</p>
          {/* mod@ccs start */}

          {/* mod@ccs end */}
        </div>
      </CSidebarBrand>
    </CSidebar>
  );
};

export default React.memo(TheSidebar);
